<template>
  <model-edition-form
    v-model="experience"
    mode="create"
    :model-name="t('experience.title')"
    :success-message="experienceSuccessMessage"
    base-url="/api/experiences/submit"
    @close="emit('close')"
  >
    <rich-text-content
      :data="experienceExplanationText"
    />
    <div class="pt-3">
      <date-picker
        v-model="experience.date"
        :error-messages="validationErrors.date ?? []"
        :error="!!validationErrors.date"
        :max="toUniversalDate(undefined)"
        :label="t('date.title')"
        :clearable="false"
        :hint="t('experience.date_hint')"
      />
    </div>
    <model-select-dropdown
      v-model="experience.location_id"
      class="pt-3"
      index-route="/api/locations"
      :index-route-parameters="{ active: true }"
      label-field-name="name"
      sort-field-name="name"
      :error-messages="validationErrors.location_id ?? []"
      :error="!!validationErrors.location_id"
      persistent-hint
      :label="t('location.title')"
      :hint="t('experience.location_hint')"
    />
    <v-text-field
      v-model="experience.title"
      name="title"
      :error-messages="validationErrors.title ?? []"
      :label="t('global.title')"
      :hint="t('experience.title_hint')"
    />
    <v-textarea
      v-model="experience.experience"
      name="experience"
      :error-messages="validationErrors.experience ?? []"
      :error="!!validationErrors.experience"
      :label="t('experience.title')"
      :hint="t('experience.experience_hint')"
    />
  </model-edition-form>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import RichTextContent from '@/components/rich-text/RichTextContent.vue';
import { useDate, useSettings } from '@/composables';
import { useErrorStore } from '@/stores/errors';
import ModelSelectDropdown from '../crud/ModelSelectDropdown.vue';
import ModelEditionForm from '../ModelEditionForm.vue';

const emit = defineEmits(['close']);
const { t } = useI18n();
const { toUniversalDate } = useDate();
const defaultItem = {
  date: toUniversalDate(undefined),
  location_id: undefined,
  title: '',
  experience: '',
};

const experience = ref<Partial<App.Models.Experience>>(defaultItem);
const { getSetting } = useSettings();
const experienceExplanationText = getSetting('experience_explanation_text');
const thankYouText = getSetting('experience_thank_you_text') ?? '';
const experienceSuccessMessage = thankYouText.length > 10
  ? thankYouText.replace(/<[^>]*>?/g, '')
  : t('experience.thank_you_text');
if (!experience.value) {
  experience.value = defaultItem;
}

const errorStore = useErrorStore();
const { validationErrors } = storeToRefs(errorStore);
</script>
